import { render, staticRenderFns } from "./Upstreams.vue?vue&type=template&id=6b43b300"
import script from "./Upstreams.vue?vue&type=script&lang=js"
export * from "./Upstreams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports